import { Dialog, Text } from "@mantine/core";
import { dialogSimulationAtom } from "../../utils/atoms/dialogSimulation";
import { useAtom } from "jotai";
import { useTranslation } from "react-i18next";

const SimulationDialog = () => {
  const { t } = useTranslation();
  const [dialogSimulation, setDialogSimulation] = useAtom(dialogSimulationAtom);
  const close = () =>
    setDialogSimulation({ ...dialogSimulation, status: false });

  return (
    <>
      <Dialog
        opened={dialogSimulation.status}
        withCloseButton
        onClose={close}
        size="lg"
        radius="md"
      >
        <Text size="sm" mb="xs" weight={500}>
          {t("simulation.dialog.projectDone", { projectId: dialogSimulation.projectId })}
        </Text>
      </Dialog>
    </>
  );
};

export default SimulationDialog;
